import { z } from "zod";

export const previousStepResponseSchema = z.object({
  new_step: z.string(),
});

export const countrySchema = z.object({
  name: z.string(),
  "alpha-3": z.string(),
  "country-code": z.string().nullish(),
});

export type Country = z.infer<typeof countrySchema>;
